import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EntityExData, EntityProvider } from "common";
import { EntityFacade } from "../../features/entity/domain/+state/entity.facade";

@Injectable()
export class MyEntityProvider extends EntityProvider {
  constructor(private readonly entityFacade: EntityFacade) {
    super();
  }

  getEntity$(companyId: number): Observable<EntityExData> {
    return this.entityFacade.getEntity$(companyId);
  }

  getEntities$(): Observable<EntityExData[]> {
    return this.entityFacade.getEntities$();
  }
}
